import type { ComponentType, PropsWithChildren, ReactNode } from 'react';
import { type JSX } from 'react';

import clsx from 'clsx';

import { Details } from '../Details';

export function MenuGroup({
  children,
  title,
  group,
}: PropsWithChildren<{
  title: string;
  group?: boolean;
}>) {
  // eslint-disable-next-line react/jsx-no-useless-fragment
  if (!group) return <>{children}</>;
  return (
    <li className="contents list-none" key={title}>
      <Details
        isOpen
        title={title}
        className="group-data-[menu=closed]/menu:[&>button>span]:sr-only [&_>_button]:box-border
          [&_>_button]:h-10"
      >
        <ul
          className={clsx(
            `relative flex w-full flex-col items-center gap-2 overflow-y-auto
            overflow-x-hidden [scrollbar-width:thin]`,
            'px-0 py-2'
          )}
        >
          {children}
        </ul>
      </Details>
    </li>
  );
}

type MenuOptionProps = {
  render: (props: {
    className: string;
    children: ReactNode;
    title: string;
  }) => JSX.Element;
  text: string;
  Icon: ComponentType<{ className?: string }>;
  active?: boolean;
};

export function MenuOption({ render, text, Icon, active }: MenuOptionProps) {
  return (
    <li className="contents list-none">
      {render({
        className: clsx(
          active
            ? 'shadow-brand shadow-[inset_8px_0px_0px_-4px] bg-gray-600 text-gray-400'
            : 'bg-gray-700 text-white',
          'grid h-9 w-full grid-cols-[1.5rem,1fr] items-center justify-items-start gap-2 rounded-sm p-2',
          'group-data-[menu=closed]/menu:grid-cols-[1fr] hover:bg-gray-600 hover:text-white'
        ),
        title: text,
        children: (
          <>
            <Icon className="h-4 w-4 min-w-[1rem] justify-self-center text-gray-800 dark:text-white" />
            <span
              className="min-w-0 truncate font-sans text-sm font-medium text-current
                group-data-[menu=closed]/menu:hidden"
            >
              {text}
            </span>
          </>
        ),
      })}
    </li>
  );
}
